module.exports = __webpack_public_path__ + "img/boleto-icon.205ac90c.svg";